/* @jsx h */
import { defineComponent, ref, h, watch, Ref } from "vue";
import {
  Cart,
  CartPersona,
  FoodType,
  Product,
  TableStatus,
} from "@lemmonhq/types";

import { calculateCartSubtotal, CartAPI } from "@lemmonhq/orders";
import { HapticButton } from "@lemmonhq/uikit";
import { POSMobileCheckoutSheet } from "./POSMobileCheckoutSheet";
import { useAuth } from "../../../providers/Auth";

export type CartButtonProps = {
  cartAPI: CartAPI;
  cart: Cart;
  onClear: Function;
  isNotesModalOpen: Ref<boolean>;
  isTableSelectModalOpen: Ref<boolean>;
  isCheckoutOpen: Ref<boolean>;
  selectedTable?: TableStatus;
  customers: CartPersona[];
  foodTypes: FoodType[];
  products: Product[];
};
export const POSMobileCartButton = defineComponent<CartButtonProps>({
  name: "CartButton",
  props: [
    "cartAPI",
    "cart",
    "onClear",
    "isNotesModalOpen",
    "isTableSelectModalOpen",
    "isCheckoutOpen",
    "selectedTable",
    "customers",
    "foodTypes",
    "products",
  ],
  setup(props) {
    const auth = useAuth();
    const { cart } = props;
    const isVisible = ref(false);
    const { isCheckoutOpen } = props;

    watch(
      () => cart.items.length,
      (newLength) => {
        isVisible.value = newLength > 0;
      },
    );

    const totalAmount = () => {
      return calculateCartSubtotal(cart);
    };

    return () => (
      <>
        <div
          class={[
            "flex-1 sticky bottom-4 left-4 right-4 transition-all duration-500 ease-out",
            isVisible.value
              ? "opacity-100 translate-y-0 pointer-events-auto"
              : "opacity-0 translate-y-full pointer-events-none",
          ]}
        >
          {cart.items.length > 0 ? (
            <div class="px-0">
              <HapticButton
                class="w-[200px] mx-auto btn btn-primary btn-sm h-10 min-h-0 rounded-md shadow-lg flex justify-between items-center gap-2 px-3 text-xs whitespace-nowrap"
                onClick={() => {
                  isCheckoutOpen.value = true;
                }}
              >
                <div class="flex items-center justify-center">
                  <span class="material-symbols-outlined text-base mr-1">
                    shopping_cart
                  </span>
                  <span>{cart.items.length} items</span>
                </div>
                <div class="flex items-center justify-center">
                  <div>
                    {totalAmount().toFixed(2)}{" "}
                    {auth.user.value?.restaurant.currency || "CHF"}
                  </div>
                  <span class="material-symbols-outlined text-base ml-0.5">
                    arrow_forward_ios
                  </span>
                </div>
              </HapticButton>
            </div>
          ) : null}
        </div>

        {isCheckoutOpen.value && (
          <POSMobileCheckoutSheet
            isOpen={isCheckoutOpen.value}
            onClose={() => (isCheckoutOpen.value = false)}
            cart={props.cart}
            cartAPI={props.cartAPI}
            onClear={props.onClear}
            isNotesModalOpen={props.isNotesModalOpen}
            isTableSelectModalOpen={props.isTableSelectModalOpen}
            selectedTable={props.selectedTable}
            customers={props.customers}
            foodTypes={props.foodTypes}
            products={props.products}
          />
        )}
      </>
    );
  },
});
